import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';

export type LanguageOption = 'auto' | 'english';
export type ToneOption = 'positive' | 'neutral' | 'negative';
export type EmojiOption = 'yes' | 'no';
export type QuestionOption = 'yes' | 'no';

@Component({
  selector: 'app-modal-prompt-generator',
  templateUrl: './modal-prompt-generator.component.html',
  styleUrls: ['./modal-prompt-generator.component.scss']
})
export class ModalPromptGeneratorComponent implements OnInit {
  language: FormControl;
  dicoLanguage: { [key in LanguageOption]: string };
  tone: FormControl;
  dicoTone: { [key in ToneOption]: string };
  useEmojis: FormControl;
  dicoUseEmojis: { [key in EmojiOption]: string };
  useQuestion: FormControl;
  dicoUseQuestion: { [key in QuestionOption]: string };
  generatedPrompt: string = '';
  promptGenerated: boolean = false;
  wordNumber: number = 0;

  channel: string = '';
  replyType: any = '';
  product: string = '';
  objective: string = '';
  role: string = '';
  websiteURL: string = '';

  public event: EventEmitter<any> = new EventEmitter();

  constructor(private modalRef: BsModalRef) {}
  ngOnInit(): void {
    this.language = new FormControl();
    this.tone = new FormControl();
    this.useEmojis = new FormControl();
    this.useQuestion = new FormControl();
    this.useEmojis.setValue('no');
    this.language.setValue('auto');
    this.tone.setValue('positive');
    this.useQuestion.setValue('no');
    this.buildDicoLanguage();
    this.buildDicoTone();
    this.buildDicoUseEmojis();
    this.buildDicoUseQuestion();
  }
  close() {
    this.modalRef.hide();
  }

  private buildDicoLanguage(): void {
    this.dicoLanguage = {
      auto: 'Auto',
      english: 'English'
    };
  }

  private buildDicoTone(): void {
    this.dicoTone = {
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative'
    };
  }

  private buildDicoUseEmojis(): void {
    this.dicoUseEmojis = {
      yes: 'Yes',
      no: 'No'
    };
  }

  private buildDicoUseQuestion(): void {
    this.dicoUseQuestion = {
      yes: 'Yes',
      no: 'No'
    };
  }

  generatePrompt(): void {
    this.generatedPrompt = '';
    this.generatedPrompt += `Act as a ${this.role != '' ? this.role : 'Community Manager'} on ${
      this.channel
    } writing a ${this.replyType} reply to a comment.\n`;
    this.generatedPrompt += this.product != '' ? `You are promoting ${this.product} in this ${this.channel} post.\n` : '';
    this.generatedPrompt +=
      this.objective != ''
        ? `The objective of the reply to the comment of this ${this.channel} post is: ${this.objective}.\n`
        : 'The page you work for does a product named ABC with the 3 main features :\n- feature 1\n- feature 2\n- feature 3\n';
    this.generatedPrompt += this.websiteURL != '' ? `Make sure you include the link to our website ${this.websiteURL} in your reply.\n` : '';
    this.generatedPrompt += 'An user commented on a post saying {{post}} the following comment :{{comment}}.\n';
    this.generatedPrompt += 'The commenter name is {{fullName}}.\n';
    this.generatedPrompt += this.language.value == 'english' ? 'Your reply will be in English under any circumstances.\n' : '';
    this.generatedPrompt += this.useEmojis.value == 'yes' ? 'You can use emojis in your reply according to the type of response.\n' : '';
    this.generatedPrompt += `The reply shall be in a ${this.tone.value} tone to the commenter.\n`;
    this.generatedPrompt +=
      this.useQuestion.value == 'yes'
        ? 'Your reply must ask a question to the commenter so that they engage more on the post and with the page\n'
        : '';
    this.generatedPrompt += this.wordNumber > 0 ? `You can have around ${this.wordNumber} words in your reply.\n` : '';
    this.promptGenerated = true;
  }

  setPrompt() {
    this.event.emit({ data: this.generatedPrompt, replyType: this.replyType });
    this.modalRef.hide();
  }
}
